'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'block-question';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e3dd';
var svgPathData = 'M448 480l-448 0 0-448 448 0 0 448zM72 384a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm304 0a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM200 352l0 48 48 0 0-48-48 0zm-8-208c-30.9 0-56 25.1-56 56l0 6.5 48 0 0-6.5c0-4.4 3.6-8 8-8l56.8 0c8.4 0 15.2 6.8 15.2 15.2 0 4.4-2.7 10.5-14.3 19.6-15.6 12.1-33.4 21.4-49.7 32.7l0 52.5 48 0 0-26.9c8.4-5.1 20.2-12 31.1-20.5 14.7-11.5 32.9-30 32.9-57.5 0-34.9-28.3-63.2-63.2-63.2L192 144zM72 80a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm304 0a24 24 0 1 0 0 48 24 24 0 1 0 0-48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBlockQuestion = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;